import { SHAPE_STROKE_PROPS } from './stroke-props';

interface ParallelogramProps {
  strokeDasharray: string | undefined;
}

export default function Parallelogram({ strokeDasharray }: ParallelogramProps) {
  return (
    <polygon
      points="20,0 100,0 80,100 0,100"
      strokeDasharray={strokeDasharray}
      {...SHAPE_STROKE_PROPS}
    />
  );
}
